import { Link } from 'react-router-dom';
import { FaLinkedin, FaGithubSquare, FaEnvelope } from 'react-icons/fa';
import { useState, useEffect } from 'react';

const descriptors = [
  'Senior Software Engineer',
  'Experience Designer',
  'Music Snob',
  'Vibe Manager',
  'Creative Technologist',
  'Emergency DJ',
  'Builder of Memories',
  'Volunteer Coordinator',
];

export default function Home() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const cycle = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % descriptors.length);
        setVisible(true);
      }, 400); // wait for fade-out before swapping text
    }, 2600);
    return () => clearInterval(cycle);
  }, []);

  return (
      <div className="Home">
        <div className="homeBox">
          <div className="myName">
            <span className="hometext">James <br/>
            Gibbs</span>
            <div
              className="homeSubtitle"
              style={{
                opacity: visible ? 1 : 0,
                transition: 'opacity 0.4s ease',
              }}
            >
              {descriptors[index]}
            </div>
          </div>
          <div className="navLinks">
            <div>
              <Link
              to="/about"
              style={{ textDecoration: "none"}}
              className="link" >
                <h3>ABOUT</h3>
              </Link>
            </div>
            <div>
              <Link to="/work"
              style={{ textDecoration: "none"}}
              className="link" >
                <h3>CODE</h3>
              </Link>
            </div>
            <div>
              <Link to="/creative"
              style={{ textDecoration: "none"}}
              className="link" >
                <h3>CRAFT</h3>
              </Link>
            </div>
          </div>
          <div className="iconLinks" >
            <div className="icons homeLink">
              <a href="https://www.linkedin.com/in/jgibbswork/" target="_blank" rel="noreferrer" aria-label="LinkedIn profile">
                <FaLinkedin aria-hidden="true" />
              </a>
            </div>
            <div className="icons homeLink">
              <a href="https://github.com/JGibbsWork" target="_blank" rel="noreferrer" aria-label="GitHub profile">
                <FaGithubSquare aria-hidden="true" />
              </a>
            </div>
            <div className="icons homeLink">
              <a href="mailto:james.gibbs@me.com" aria-label="Send email">
                <FaEnvelope aria-hidden="true" />
              </a>
            </div>
          </div>

        </div>
      </div>
  )
}